import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { TabData } from './types';

const QUERY_KEY = ['mass-editor-entities'];

async function fetchTabData(): Promise<TabData> {
    const res = await fetch('/api/mass-editor/entities');
    if (!res.ok) throw new Error('Impossible de charger les données de l\'éditeur en masse');
    return res.json() as Promise<TabData>;
}

async function applyChanges(data: Partial<TabData>): Promise<void> {
    const res = await fetch('/api/mass-editor/entities/apply', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Impossible de sauvegarder les modifications');
}

export function useMassEditorData() {
    return useQuery({
        queryKey: QUERY_KEY,
        queryFn: fetchTabData,
    });
}

export function useApplyMassEditorChanges() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: applyChanges,
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: QUERY_KEY });
        },
    });
}
